/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

export class StartTimerEvent extends Event {
  message?: string;
  due: Date;
  duration: number;
  identifier?: object;

  constructor(type: string, due: number, duration: number, message?: string, identifier?: object) {
    super(type, { bubbles: true });

    this.message = message;
    this.due = new Date(due);
    this.duration = duration;
    this.identifier = identifier;
  }
}
